import { PlannedWorkShiftSaveDto } from "../plannedWorkShift/plannedWorkShift";

export interface RecurringShift {
    recurringShiftId: string;
    rowId: string;
    employeeId?: string;
    vehicleId?: string;
    routeId?: string;
    recurrenceStartDate: string;
    recurrenceEndDate?: string;
    intervalInWeeks: number;
    repeatDays: number;
    label?: string;
    comment?: string;
    startTime: string;
    endTime: string;
}

export enum RepeatEnabledDays16 {
    None = 0,
    Monday1 = 1 << 0,
    Tuesday1 = 1 << 1,
    Wednesday1 = 1 << 2,
    Thursday1 = 1 << 3,
    Friday1 = 1 << 4,
    Saturday1 = 1 << 5,
    Sunday1 = 1 << 6,
}

export interface RecurringShiftInstanceDto {
    recurringShiftId: string;
    recurringShiftRowId: string;
    date: string;
    type: RecurringShiftInstanceType; // "Skip" or "Override"
    shift?: PlannedWorkShiftSaveDto;
}

export interface RecurringShiftEditDto {
    rowId: string;
    startDate: string;
    endDate: string;
    intervalInWeeks: number;
    repeatDays: number;
    splitFromDate?: string;
    startTime: string;
    endTime: string;
    label: string | null;
    comment: string | null;
    employeeId: string | null;
    vehicleId: string | null;
    routeId: string | null;
}

export enum RecurringShiftInstanceType {
    Skip = 0, // Deleted instance
    Override = 1, // Edited instance
    Generate = 2, // Generated instance
}